import React, { useEffect, useState } from "react";
import styles from "./NewsletterModal.module.scss";

import _ from "../../i18n";
import {
  DAYS,
  NL_PLANS,
  SELECT_STYLES,
  SELECT_STYLES_NEWSLETTER,
  TTP_API_URL,
} from "../../config";
import Select from "react-select";
import CollaboratorBlock from "./CollaboratorBlock";
import Loader from "../common/Loader";
import { toast } from "react-toastify";
import Switch from "../common/Switch/Switch";
import CollaboratorFrom from "./CollaboratorFrom";
import IconPlus from "../common/icons/IconPlus";
import { useSelector } from "react-redux";
import IconAlertTriangle from "../common/icons/IconAlertTriangle";
import classNames from "classnames";
import { getNewsletterThemes } from "../../api/newsletter";
import IconExternalLink from "../common/icons/IconExternalLink";
import IconClose from "../common/icons/IconClose";
import TemplateSelect from "./TemplateSelect";

const NewsletterSettings = ({
  newsletterPlan,
  frequency,
  setFrequency,
  frequencyTabs,
  collaborators,
  senders,
  setSenders,
  setSlide,
  verifiedEmailsList,
  handleFetchVerifiedEmails,
  isVerifiedEmailsLoading,
  isLogoUaVisible,
  setIsLogoUaVisible,
  domains,
  handleVerifyDomain,
  setSelectedDomain,
  activeFrequencyTab,
  setActiveFrequencyTab,
  activeConfig,
  updateActiveConfig,
  isVerifying,
  setIsVerifying,
}) => {
  const fiduciary = useSelector((state) => state.folder.fiduciary);
  const auth = useSelector((state) => state.auth);
  const [collaboratorList, setCollaboratorList] = useState([]);
  const [isVisible, setIsVisible] = useState(false);
  const [templatesList, setTemplatesList] = useState([]);
  const [templatesPage, setTemplatesPage] = useState(0);
  const [templatesHasMore, setTemplatesHasMore] = useState(true);
  const [templatesLoading, setTemplatesLoading] = useState(false);
  const [previewThemeId, setPreviewThemeId] = useState(null);

  const hours = Array.from({ length: 24 }, (_, i) => ({
    value: i < 10 ? `0${i}` : `${i}`,
    label: i < 10 ? `0${i}` : `${i}`,
  }));

  const minutes = Array.from({ length: 60 }, (_, i) => ({
    value: i < 10 ? `0${i}` : `${i}`,
    label: i < 10 ? `0${i}` : `${i}`,
  }));

  useEffect(() => {
    if (isVerifiedEmailsLoading) return;
    const collab_list =
      collaborators?.map((collaborator) => {
        const matchedEmail = verifiedEmailsList.find(
          (emailObj) => emailObj.email === collaborator.mainEmail
        );
        return {
          value: collaborator.id,
          label: `${collaborator.firstName} ${collaborator.lastName}`,
          email: collaborator.mainEmail,
          status: matchedEmail ? matchedEmail.VerificationStatus : "Failed",
        };
      }) ?? [];
    setCollaboratorList(collab_list);
  }, [isVerifiedEmailsLoading, collaborators, verifiedEmailsList]);

  useEffect(() => {
    if (!auth.token || !fiduciary?.id) return;
    loadTemplates(0);
  }, [auth.token, fiduciary?.id]);

  const handleRemoveClick = (sender) => {
    setSenders(senders.filter((item) => item.value !== sender.value));

    if (!collaboratorList.some((item) => item.email === sender.email)) {
      setCollaboratorList([sender, ...collaboratorList]);
    }
  };

  const LANGUAGE_OPTIONS = [
    { value: "FR", label: _("french") },
    { value: "NL", label: _("dutch") },
    { value: "EN", label: _("english") },
  ];

  const handleNewslettersPerPeriodChange = (opt) => {
    const count = opt.value;
    const existing = activeConfig.schedules;
    const updated = [...existing];
    while (updated.length < count) {
      updated.push({
        id: updated.length + 1,
        day: DAYS[0],
        hour: { value: "08", label: "08" },
        minutes: { value: "00", label: "00" },
      });
    }
    const langs = [...activeConfig.languages];
    while (langs.length < count) {
      langs.push({ id: langs.length + 1, language: "FR" });
    }
    updateActiveConfig({
      newslettersPerPeriod: count,
      schedules: updated.slice(0, count),
      languages: langs.slice(0, count),
    });
  };

  const handleLanguageChange = (index, value) => {
    const updated = [...activeConfig.languages];
    updated[index] = { ...updated[index], language: value };
    updateActiveConfig({ languages: updated });
  };

  const handleScheduleChange = (index, field, value) => {
    const updated = [...activeConfig.schedules];
    updated[index] = { ...updated[index], [field]: value };
    updateActiveConfig({ schedules: updated });
  };

  const currentSchedules = activeConfig.schedules ?? [];

  const loadTemplates = (page = 0) => {
    if (templatesLoading || (!templatesHasMore && page > 0)) return;

    setTemplatesLoading(true);

    getNewsletterThemes({
      token: auth.token,
      clientId: fiduciary.id,
      limit: 20,
      offset: page * 20,
    }).then((res) => {
      const newItems = res.data.data.map((t) => ({
        value: t.id,
        label: t.name,
      }));

      setTemplatesList((prev) =>
        page === 0 ? newItems : [...prev, ...newItems]
      );
      setTemplatesHasMore(newItems.length === 20);
      setTemplatesPage(page);
      setTemplatesLoading(false);
    });
  };
  const getPreviewUrl = (themeId) => {
    return `${TTP_API_URL}/mailing/web-version?themeId=${themeId}&textModelId=&access_token=${auth.token}`;
  };

  const searchTemplates = (search) => {
    setTemplatesPage(0);
    setTemplatesHasMore(true);
    setTemplatesList([]);

    getNewsletterThemes({
      token: auth.token,
      clientId: fiduciary.id,
      search: search || null,
      limit: 20,
      offset: 0,
    }).then((res) => {
      const items = res.data.data.map((t) => ({
        value: t.id,
        label: t.name,
      }));
      setTemplatesList(items);
      setTemplatesHasMore(items.length === 20);
    });
  };
  return (
    <div className={"cell small-12 medium-12"}>
      <div
        className={`grid-x
            ${styles.config}`}
      >
        <div
          className={`cell small-12 medium-2 
            ${styles.mail_list}`}
        >
          <span className={styles.title}> {_("define_sender")}</span>
          <span className={styles.sub_title}>
            {" "}
            {_("manage_sending_emails")}
          </span>
          <div className={`grid-x ${styles.container_select}`}>
            <div className={`cell small-10 ${styles.sender_select}`}>
              {isVisible ? (
                <p className={styles.sender_title}>{_("new_sender")}</p>
              ) : (
                <Select
                  styles={SELECT_STYLES}
                  className={styles.sender_options}
                  options={collaboratorList.filter(
                    (item) =>
                      !senders
                        .map((sender) => sender.value)
                        .includes(item.value)
                  )}
                  isSearchable={true}
                  isClearable={false}
                  value={""}
                  inputProps={{
                    autoComplete: "off",
                  }}
                  onChange={(e) => {
                    if (
                      (newsletterPlan === "LITE" && senders.length === 0) ||
                      (["PERSONALIZED", "STANDARD"].includes(newsletterPlan) &&
                        senders.length < 20)
                    ) {
                      setSenders([e, ...senders]);
                      setCollaboratorList(
                        collaboratorList.filter(
                          (collaborator) => collaborator.value !== e.value
                        )
                      );
                    } else {
                      toast.info(
                        _(
                          "Vous avez atteint la limite des expéditeurs prévue par ce plan "
                        )
                      );
                    }
                  }}
                  isLoading={isVerifiedEmailsLoading}
                />
              )}
            </div>
            <div
              className={`cell small-2 ${styles.sender_add_icon}`}
              onClick={() => {
                setIsVisible(!isVisible);
              }}
            >
              <IconPlus
                style={{
                  transform: isVisible ? "rotate(-45deg)" : "rotate(0deg)",
                  transition: "transform 0.5s ease",
                }}
              />
            </div>
          </div>
          <div className={styles.separator} />
          {senders.length > 0 && !isVisible && (
            <span className={styles.senders_count}>
              {senders.length} expéditeur(s) :
            </span>
          )}
          <div className={styles.senders_list}>
            {isVerifiedEmailsLoading ? (
              <Loader
                style={{ height: "13px", margin: "15% 30%" }}
                color={"#06d9b1"}
              />
            ) : isVisible ? (
              <CollaboratorFrom
                collaboratorList={collaboratorList}
                setCollaboratorList={setCollaboratorList}
                senders={senders}
                setSenders={setSenders}
                setIsVisible={setIsVisible}
              />
            ) : (
              senders.length > 0 &&
              senders.map((sender) => (
                <CollaboratorBlock
                  key={sender.value}
                  sender={sender}
                  removeClick={handleRemoveClick}
                  verifiedEmailsList={verifiedEmailsList}
                  handleFetchVerifiedEmails={handleFetchVerifiedEmails}
                  domains={domains}
                  handleVerifyDomain={handleVerifyDomain}
                  setSlide={setSlide}
                  setSelectedDomain={setSelectedDomain}
                  isVerifying={isVerifying}
                  setIsVerifying={setIsVerifying}
                />
              ))
            )}
          </div>
        </div>
        <div
          className={`cell small-12 medium-10 
            ${styles.config_details}`}
        >
          <div className={styles.details}>
            <span className={styles.title}>
              {_("program_nl_title")}
              {NL_PLANS.find((plan) => plan.value === newsletterPlan)?.label ??
                newsletterPlan}
              )
            </span>
            {fiduciary.uaMode !== "OECCBB_MEMBER" && (
              <span className={styles.title_link} onClick={() => setSlide(1)}>
                {_("change_plan")}
              </span>
            )}
          </div>
          <span className={styles.sub_title}> {_("program_nl_desc")}</span>

          <div className={styles.config_block}>
            {newsletterPlan === "PERSONALIZED" && (
              <div className={styles.show_logo}>
                <span className={styles.details_title}>Logo UA :</span>
                <Switch
                  isChecked={isLogoUaVisible}
                  onChange={() => setIsLogoUaVisible(!isLogoUaVisible)}
                />
              </div>
            )}
            <div className={styles.config_item}>
              <span className={styles.details_title}>
                {_("articles_option_3")} :
              </span>
              <Select
                styles={{
                  ...SELECT_STYLES_NEWSLETTER,
                  multiValueRemove: (base) =>
                    newsletterPlan !== "PERSONALIZED"
                      ? { ...base, display: "none" }
                      : base,
                }}
                options={frequencyTabs}
                isSearchable={false}
                isClearable={false}
                isMulti={true}
                value={frequency}
                onChange={(selected) => setFrequency(selected || [])}
                isDisabled={newsletterPlan !== "PERSONALIZED"}
              />
            </div>

            {newsletterPlan === "PERSONALIZED" && (
              <>
                {frequency.length > 1 && (
                  <div className={styles.frequency_tabs}>
                    {frequency.map((f) => (
                      <button
                        key={f.value}
                        className={classNames(
                          styles.frequency_tab,
                          activeFrequencyTab === f.value &&
                            styles.frequency_tab_active
                        )}
                        onClick={() => setActiveFrequencyTab(f.value)}
                      >
                        {f.label}
                      </button>
                    ))}
                  </div>
                )}
                <div
                  className={
                    frequency.length > 1
                      ? styles.multi_tab_block
                      : styles.multi_tab
                  }
                >
                  <div className={styles.config_item}>
                    <span className={styles.details_title}>
                      {_("newsletters_count")}:
                    </span>
                    <div className={styles.time_select}>
                      <Select
                        styles={SELECT_STYLES}
                        isSearchable={false}
                        isClearable={false}
                        value={{
                          value: activeConfig.newslettersPerPeriod,
                          label: activeConfig.newslettersPerPeriod,
                        }}
                        options={[1, 2, 3, 4].map((n) => ({
                          value: n,
                          label: n,
                        }))}
                        onChange={handleNewslettersPerPeriodChange}
                      />
                    </div>
                  </div>
                  {activeConfig.newslettersPerPeriod > 1 ? (
                    <>
                      {/* Warning */}
                      <div className={styles.planning_warning}>
                        <IconAlertTriangle />
                        <div>
                          <strong>{_("planning_per_newsletter")}</strong>
                          <p>{_("planning_per_newsletter_desc")}</p>
                          <p>
                            <s>{_("planning_single_slot")}</s> →{" "}
                            {_("planning_dedicated_slot")}
                          </p>
                        </div>
                      </div>

                      {/* Header tableau */}
                      <div className={styles.planning_individual_header}>
                        <span>• {_("planning_individual")}</span>
                      </div>

                      {/* Colonnes */}
                      <table className={styles.planning_table}>
                        <thead>
                          <tr>
                            <th></th>
                            <th>{_("planning_col_language")}</th>
                            <th>{_("planning_col_day")}</th>
                            <th>{_("planning_col_hour")}</th>
                            <th>{_("template")}</th>
                          </tr>
                        </thead>
                        <tbody>
                          {currentSchedules.map((schedule, index) => {
                            const lang = activeConfig.languages[index];
                            return (
                              <tr key={schedule.id}>
                                <td className={styles.planning_nl_name}>
                                  {_("newsletter_label")} {index + 1}
                                </td>

                                <td>
                                  <Select
                                    styles={SELECT_STYLES}
                                    options={LANGUAGE_OPTIONS}
                                    isClearable={false}
                                    isSearchable={false}
                                    value={LANGUAGE_OPTIONS.find(
                                      (l) => l.value === lang?.language
                                    )}
                                    onChange={(e) =>
                                      handleLanguageChange(index, e.value)
                                    }
                                  />
                                </td>

                                <td>
                                  <Select
                                    styles={SELECT_STYLES}
                                    options={DAYS}
                                    isSearchable={false}
                                    isClearable={false}
                                    value={schedule.day}
                                    onChange={(e) =>
                                      handleScheduleChange(index, "day", e)
                                    }
                                  />
                                </td>

                                <td>
                                  <div className={styles.time_cell}>
                                    <Select
                                      styles={SELECT_STYLES}
                                      options={hours}
                                      isSearchable={false}
                                      isClearable={false}
                                      value={schedule.hour}
                                      onChange={(e) =>
                                        handleScheduleChange(index, "hour", e)
                                      }
                                    />
                                    <span>:</span>
                                    <Select
                                      styles={SELECT_STYLES}
                                      options={minutes}
                                      isSearchable={false}
                                      isClearable={false}
                                      value={schedule.minutes}
                                      onChange={(e) =>
                                        handleScheduleChange(
                                          index,
                                          "minutes",
                                          e
                                        )
                                      }
                                    />
                                  </div>
                                </td>
                                <td>
                                  <TemplateSelect
                                    value={schedule.themeId ?? null}
                                    onChange={(themeId) => {
                                      const updated = [
                                        ...activeConfig.schedules,
                                      ];
                                      updated[index] = {
                                        ...updated[index],
                                        themeId,
                                      };
                                      updateActiveConfig({
                                        schedules: updated,
                                      });
                                    }}
                                    onPreview={setPreviewThemeId}
                                    templatesList={templatesList}
                                    templatesLoading={templatesLoading}
                                    templatesHasMore={templatesHasMore}
                                    templatesPage={templatesPage}
                                    loadTemplates={loadTemplates}
                                    searchTemplates={searchTemplates}
                                  />
                                </td>
                              </tr>
                            );
                          })}
                        </tbody>
                      </table>
                    </>
                  ) : (
                    // Case newslettersPerPeriod === 1
                    <>
                      <div className={styles.config_item}>
                        <span className={styles.details_title}>
                          {_("planning_day")} :
                        </span>
                        <Select
                          styles={SELECT_STYLES}
                          options={DAYS}
                          isSearchable={false}
                          isClearable={false}
                          value={activeConfig.planningDay ?? DAYS[0]}
                          onChange={(e) =>
                            updateActiveConfig({ planningDay: e })
                          }
                        />
                      </div>
                      <div className={styles.config_item}>
                        <span className={styles.details_title}>
                          {_("planning_hour")} :
                        </span>
                        <div className={styles.time_select}>
                          <Select
                            styles={SELECT_STYLES}
                            options={hours}
                            isSearchable={false}
                            isClearable={false}
                            value={
                              activeConfig.planningHour ?? {
                                value: "08",
                                label: "08",
                              }
                            }
                            onChange={(e) =>
                              updateActiveConfig({ planningHour: e })
                            }
                          />
                        </div>
                        <span className={styles.space}>:</span>
                        <div className={styles.minute_select}>
                          <Select
                            styles={SELECT_STYLES}
                            options={minutes}
                            isSearchable={false}
                            isClearable={false}
                            value={
                              activeConfig.planningMinutes ?? {
                                value: "00",
                                label: "00",
                              }
                            }
                            onChange={(e) =>
                              updateActiveConfig({ planningMinutes: e })
                            }
                          />
                        </div>
                      </div>
                      <div className={styles.config_item}>
                        <span className={styles.details_title}>
                          {_("template")} :
                        </span>
                        <TemplateSelect
                          value={activeConfig.themeId ?? null}
                          onChange={(themeId) =>
                            updateActiveConfig({ themeId })
                          }
                          onPreview={setPreviewThemeId}
                          templatesList={templatesList}
                          templatesLoading={templatesLoading}
                          templatesHasMore={templatesHasMore}
                          templatesPage={templatesPage}
                          loadTemplates={loadTemplates}
                          searchTemplates={searchTemplates}
                        />
                      </div>
                    </>
                  )}{" "}
                </div>
              </>
            )}
          </div>
        </div>
      </div>
      {/* Modal aperçu template */}
      {previewThemeId && (
        <div
          className={styles.preview_overlay}
          onClick={() => setPreviewThemeId(null)}
        >
          <div
            className={styles.preview_modal}
            onClick={(e) => e.stopPropagation()}
          >
            <div
              className={styles.preview_close}
              onClick={() => setPreviewThemeId(null)}
            >
              <IconClose size={14} />{" "}
            </div>
            {/* Header avec URL + bouton fermer */}
            <div className={styles.preview_header}>
              <input
                className={styles.preview_url}
                value={getPreviewUrl(previewThemeId)}
                readOnly
              />
              <a
                href={getPreviewUrl(previewThemeId)}
                target="_blank"
                rel="noreferrer"
                className={styles.preview_open}
              >
                <IconExternalLink size={18} />
              </a>
            </div>
            {/* Iframe */}
            <div className={styles.preview_body}>
              <iframe
                src={getPreviewUrl(previewThemeId)}
                width="100%"
                height="100%"
                frameBorder="0"
                title="Aperçu template"
              />
            </div>{" "}
          </div>
        </div>
      )}
    </div>
  );
};

export default NewsletterSettings;
